export enum ApiChecksEnum {
  /** POST */
  voucherCorrectSum = '/api/Receipts/CorrectCheckSum',

  /** GET with IFilterQuery query params */
  voucherList = '/api/Receipts',

  /** GET with {voucher ID} */
  voucherDetails = '/api/Receipts/',

  /** DELETE with {voucher ID} */
  deleteVoucher = '/api/Receipts/',

  /** GET with filters */
  search = '/api/Receipts/Search',

  uploadVouchers = '/api/Receipts/UploadMagnitChecks',
}
